import { useState, useRef } from "react";
import { getATMUnitDistricts, getCount, searchAdminUnits, getATMUnitStates } from "./Utility/util";

import {
  getATMStates,
  getATMDistricts,
  searchATMs,
} from "./Utility/util";
import "./ATMBranchLocator.css";

export default function BranchLocator() {
  const [locatorType, setLocatorType] = useState("");

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [statesLoading, setStatesLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtLoading, setDistrictLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [count, setCount] = useState(0);
  const [noLocatorError, setnoLocatorError] = useState("");
  const [branch, setBranch] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [directSearch, setDirectSearch] = useState("");

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const closeBtnRef = useRef(null);
  const resultRef = useRef(null);
  const lastFocusedElement = useRef(null);
  const pageSize = 5;
  const handleLocatorChange = async (e) => {
    const value = e.target.value;

    setnoLocatorError("");
    setLocatorType(value);
    setStates([]);
    setSelectedState("");
    setDistricts([]);
    setSelectedDistrict("");
    setBranch("");
    setDirectSearch("");
    setResults([]);

    if (!value) return;
    //Getting Total count
    const applicationsCount = await getCount(value);
    setCount(applicationsCount);
    setStatesLoading(true);


    try {
      let list = [];

      if (value === "BRANCH") {
        list = await getATMStates();
      }

      if (value === "ADMIN") {
        list = await getATMUnitStates();
      }

      setStates(list);
    } finally {
      setStatesLoading(false);
    }
  };
  const handleStateChangeByLocator = async (e) => {
    const value = e.target.value;

    setSelectedState(value);
    setSelectedDistrict("");
    setBranch("");
    setDirectSearch("");
    setResults([]);
    setDistricts([]);

    if (!value || !locatorType) return;

    setDistrictLoading(true);
    try {
      let list = [];

      if (locatorType === "BRANCH") {
        list = await getATMDistricts(value);
      }

      if (locatorType === "ADMIN") {
        console.log("ADMIN")
        list = await getATMUnitDistricts(value);
      }

      setDistricts(list);
    } finally {
      setDistrictLoading(false);
    }
  };

  const handleStateChange = async (e) => {
    const value = e.target.value;

    setSelectedState(value);
    setSelectedDistrict("");
    setBranch("");
    setDirectSearch("");
    setResults([]);
    setDistricts([]);

    if (!value) return;

    setDistrictLoading(true);
    try {
      const list = await getATMDistricts(value);
      setDistricts(list);
    } finally {
      setDistrictLoading(false);
    }
  };

  const handleView = async (newPage = 1) => {
    if (directSearch != null && locatorType === "") {
      setnoLocatorError("Please select Branch Locator");
      return;
    }

    setnoLocatorError("");
    setHasSearched(true);
    setLoading(true);
    setPage(newPage);

    try {
      let response;

      if (locatorType === "BRANCH") {
        if (directSearch.trim()) {
          response = await searchATMs(
            null,
            null,
            null,
            directSearch.trim(),
            newPage,
            pageSize
          );
        } else if (selectedState && selectedDistrict) {
          response = await searchATMs(
            selectedState,
            selectedDistrict,
            branch || null,
            null,
            newPage,
            pageSize
          );
        }
      } else if (locatorType === "ADMIN") {
        if (directSearch.trim()) {
          response = await searchAdminUnits(
            null,
            null,
            null,
            directSearch.trim(),
            newPage,
            pageSize
          );
        } else if (selectedState && selectedDistrict) {
          response = await searchAdminUnits(
            selectedState,
            selectedDistrict,
            branch || null,
            null,
            newPage,
            pageSize
          );
        }

      }
      setResults(response?.items || []);
      setTotalCount(response?.totalCount || 0);
      setTimeout(() => {
        resultRef.current?.focus();
      }, 300);

    } finally {
      setLoading(false);
    }
  };


  const openModal = (row, event) => {
    lastFocusedElement.current = event.currentTarget;

    setSelectedRow(row);
    setShowModal(true);

    setTimeout(() => {
      closeBtnRef.current?.focus();
    }, 100);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRow(null);
    setTimeout(() => {
      lastFocusedElement.current?.focus();
    }, 100);
  };

  const branchLabel =
    locatorType === "BRANCH"
      ? "Branch Name"
      : locatorType === "ADMIN"
        ? "Admin Unit Name"
        : "Branch / Admin Unit";
  return (
    <div className="atm-wrapper">
      <div className="atm-container">
        <div className="atm-top-action">
          <a
            href="/web/guest/atm-locator"
            className="atm-cta-btn"
          >
            Click here for ATM Locator
          </a>
        </div>

        {/* ROW 1 */}
        <div className="atm-row">
          <div className="atm-field">
            <label htmlFor="branch-locator">
              Branch Locator <span aria-hidden="true">*</span>
              <span className="sr-only"> required</span>
            </label>

            <select
              id="branch-locator"
              value={locatorType}
              onChange={handleLocatorChange}
              required
              aria-required="true"
            >
              <option value="" disabled hidden>
                Select
              </option>

              <option value="BRANCH">
                Branch Details
              </option>

              <option value="ADMIN">
                Admin Unit
              </option>
            </select>

            {locatorType && (
              <span id="count">
                Total Branches : {count}
              </span>
            )}
          </div>

          <div className="atm-field">
            <label htmlFor="state-select">
              State <span aria-hidden="true">*</span>
              <span className="sr-only"> required</span>
            </label>


            {statesLoading ? (
              <div role="status" aria-live="polite">Loading states…</div>
            ) : (
              <select
                id="state-select"
                value={selectedState}
                onChange={handleStateChangeByLocator}
                disabled={!locatorType}
                required
                aria-required="true"
              >
                <option value="" disabled hidden>
                  Select State
                </option>

                {states.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>

        {/* ROW 2 */}
        <div className="atm-row">
          <div className="atm-field">
            <label htmlFor="district-select">
              District <span aria-hidden="true">*</span>
              <span className="sr-only"> required</span>
            </label>

            {districtLoading ? (
              <div role="status" aria-live="polite">Loading districts…</div>
            ) : (
              <select
                id="district-select"
                value={selectedDistrict}
                onChange={(e) => {
                  setSelectedDistrict(e.target.value);
                  setDirectSearch("");
                }}
                disabled={!selectedState}
                required
                aria-required="true"
              >
                <option value="" disabled hidden>
                  Select District
                </option>

                {districts.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="atm-field">
            <label htmlFor="branch-select">
              {branchLabel}
            </label>

            <select
              id="branch-select"
              value={branch}
              onChange={(e) =>
                setBranch(e.target.value)
              }
              disabled={!selectedDistrict}
            >
              <option value="">
                All
              </option>

              <option value="All">
                All
              </option>
            </select>
          </div>
        </div>

        {/* OR */}
        <div className="atm-or">OR</div>

        {/* DIRECT SEARCH */}
        <div className="atm-row">
          <div className="atm-field full-width">
            <label htmlFor="direct-search">
              Search By DPCODE / PINCODE /
              MICR / IFSC / ADDRESS / Email
              <br />
              and click on <strong>VIEW</strong>
            </label>

            <input
              id="direct-search"
              type="text"
              placeholder="Enter DPCODE / PIN / MICR / IFSC / Email"
              value={directSearch}
              onChange={(e) => {
                setDirectSearch(e.target.value);
                setSelectedState("");
                setSelectedDistrict("");
                setBranch("");
              }}
            />

            {noLocatorError && (
              <small
                className="text-danger"
                role="alert"
                aria-live="assertive"
              >
                {noLocatorError}
              </small>
            )}
          </div>
        </div>

        {/* VIEW BUTTON */}
        <div className="atm-row">
          <button
            type="button"
            className="atm-search-btn"
            onClick={() => handleView(1)}
            disabled={loading || (!directSearch.trim() &&
              (!selectedState || !selectedDistrict))}
            aria-busy={loading}
            aria-describedby="search-status"
          >
            {loading ? "Loading..." : "View"}
          </button>
        </div>
        <div
          id="search-status"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className="sr-only"
        >
          {!loading && hasSearched && (
            results.length > 0
              ? `${totalCount} results found`
              : "No results found"
          )}
        </div>

        {/* RESULTS TABLE */}
        {(results.length > 0 || hasSearched) && (
          <div
            ref={resultRef}
            tabIndex="-1"
            role="region"
            aria-label="Search Results"
          >
            <table className="atm-table">
              <caption className="sr-only">
                ATM Branch Search Results
              </caption>
              <thead>
                <tr>
                  <th>DP CODE</th>
                  <th>Branch Name</th>
                  <th>State</th>
                  <th>District</th>
                  <th>Pin Code</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  </tr>
                ) : results.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  results.map((r) => (
                    <tr key={r.id}>
                      <td>
                        <button
                          type="button"
                          className="link" style={{ border: "none", background: "none" }}
                          onClick={(e) => openModal(r, e)}
                        >
                          {r.dPCODE}
                        </button>
                      </td>
                      <td>
                        <button
                          aria-label={`View details for ${r.branchName}`}
                          type="button"
                          className="link" style={{ border: "none", background: "none" }}
                          onClick={(e) => openModal(r, e)}
                        >
                          {r.branchName}
                        </button>

                      </td>
                      <td>{r.state}</td>
                      <td>{r.district}</td>
                      <td>{r.pincode}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
        {totalCount > pageSize && (
          <div className="pagination">
            <button
              aria-label="Previous Page"
              disabled={page === 1}
              onClick={() => handleView(page - 1)}
            >
              Previous
            </button>

            <span>
              Page {page} of {Math.ceil(totalCount / pageSize)}
            </span>

            <button
              aria-label="Next Page"
              disabled={page * pageSize >= totalCount}
              onClick={() => handleView(page + 1)}
            >
              Next
            </button>
          </div>
        )}


        {/* MODAL */}
        {showModal && selectedRow && (
          <div className="modal-backdrop">
            <div
              className="modal-box"
              role="dialog"
              aria-modal="true"
              aria-labelledby="branch-details-title"
            >
              <h3 id="branch-details-title">BRANCH DETAILS</h3>

              <table className="modal-table">
                <tbody>
                  <tr>
                    <td>Branch/Office Name</td>
                    <td>{selectedRow.branchName}</td>
                    <td>DP CODE</td>
                    <td>{selectedRow.dPCODE}</td>
                  </tr>
                  <tr>
                    <td>Pin Code</td>
                    <td>{selectedRow.pincode}</td>
                    <td>Address</td>
                    <td>{selectedRow.address1}</td>
                  </tr>
                  <tr>
                    <td>Email ID</td>
                    <td>{selectedRow.eMailID}</td>
                    <td>Regional Office</td>
                    <td>{selectedRow.regionNameStatus}</td>
                  </tr>
                  <tr>
                    <td>Circle</td>
                    <td>{selectedRow.circle}</td>
                    <td>MICR Code</td>
                    <td>{selectedRow.mICR || "N/A"}</td>
                  </tr>
                  <tr>
                    <td>IFSC Code</td>
                    <td>{selectedRow.iFSC}</td>
                    <td>Mobile</td>
                    <td>{selectedRow.contact2}</td>
                  </tr>
                  <tr>
                    <td>STD Code</td>
                    <td>—</td>
                    <td>Phone Number</td>
                    <td>{selectedRow.contact1}</td>
                  </tr>
                </tbody>
              </table>

              <button ref={closeBtnRef} className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
